import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Create Supabase client only if credentials are available
let supabase = null;

const createMockBuilder = () => {
  const promise = Promise.resolve({ data: null, error: null });
  const builder = {
    select: () => builder,
    insert: () => builder,
    update: () => builder,
    delete: () => builder,
    order: () => builder,
    eq: () => builder,
    neq: () => builder,
    single: () => Promise.resolve({ data: null, error: null }),
    maybeSingle: () => Promise.resolve({ data: null, error: null }),
    limit: () => builder,
    range: () => builder,
    then: (onfulfilled, onrejected) => promise.then(onfulfilled, onrejected),
    catch: (onrejected) => promise.catch(onrejected),
  };
  return builder;
};

if (supabaseUrl && supabaseKey) {
  supabase = createClient(supabaseUrl, supabaseKey);
} else {
  // Return a robust mock object to prevent errors when Supabase is not configured
  supabase = {
    from: () => createMockBuilder(),
    auth: {
      signInWithPassword: () => Promise.resolve({ data: null, error: null }),
      signOut: () => Promise.resolve({ error: null }),
      getUser: () => Promise.resolve({ data: { user: null }, error: null }),
    },
    storage: {
      from: () => ({
        upload: () => Promise.resolve({ data: null, error: null }),
        getPublicUrl: () => ({ data: { publicUrl: '' } }),
      })
    }
  };
  console.warn('Supabase not configured. Using robust mock client.');
}

export { supabase };
